module.exports = __webpack_public_path__ + "static/img/zhengshu.5c0cfd4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/zhengshu.jpeg
// module id = QWzS
// module chunks = 1